import { createAction, props } from "@ngrx/store";
import { ProjectType } from "src/app/features/auth/types/project-type.type";

export const initializeTokenValue = createAction(
  'App.InitializeTokenValue',
  props<{
    token: string,
    userId: number,
    storedAccountId?: number, // accountId stored in cookie, which is the last account user logged in, used for auto selecting account when user has multiple accounts
    accountId: number,
    accountIds: number[],
    accountType: ProjectType,
    role: string,
  }>()
);
